<template>
  <div class="lg:mt-10 md:mt-9 mt-5 gap-4">
    <div class="container">
      <div class="grid lg:grid-cols-2 grid-cols-1 gap-6">
        <div
          class="w-full grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-6"
        >
          <div class="gap-4 mt-12">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Neurological%20Disorders1.jpg"
              alt="cancer"
              class="treate2 object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Neurological%20Disorders2.jpg"
              alt="cancer"
              class="treate2 object-cover mt-4"
            />
          </div>
          <div class="gap-4">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Neurological%20Disorders3.jpg"
              alt="cancer"
              class="treate1 object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Neurological%20Disorders4.jpg"
              alt="cancer"
              class="treate1 object-cover mt-4"
            />
          </div>
        </div>
        <div class="">
          <h2 class="text4F0A4B font-semibold fsize24 sm-fsize16 mb-2">
            What is Neurological Disorders?
          </h2>
          <p class="lg:mt-4 md:mt-4 mt-2 sm-fsize14">
            Neurological disorders refer to conditions that affect the nervous
            system, which includes the brain, spinal cord, and nerves. These
            disorders can impact a person's ability to move, speak, think, and
            feel. Neurological disorders can be caused by a variety of factors,
            including genetics, infections, injuries, and environmental factors.
            The impact of these disorders can vary greatly, ranging from mild to
            severe.
          </p>
          <br />
          <p>
            Neurological Disorders are a group of conditions that affect the
            functioning of the brain and the nervous system. These disorders are
            characterized by the progressive loss of neurons, leading to a
            decline in cognitive, motor, and sensory functions. Some of the most
            common Neurological Disorders include Alzheimer's disease,
            Parkinson's disease, Huntington's disease, and Amyotrophic Lateral
            Sclerosis (ALS).
          </p>
        </div>
      </div>
      <div class="mt-8">
        <h2 class="text4F0A4B font-semibold fsize24 sm-fsize16 mb-2">
          Types of Neurological Disorders
        </h2>
        <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
          There are several broad types of neurological disorders, each with its
          own unique set of symptoms and treatment options. Some of the most
          common types of neurological disorders include:
        </p>
        <div
          class="mt-5 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 w-full"
        >
          <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              EPILEPSY & STROKE
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Epilepsy and stroke are two neurological conditions that can have
              a significant impact on a person's quality of... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'first')"
                >Show More</span
              >
            </p>
          </div>
          <!-- <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              Neurological DISORDERS
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Neurological Disorders are a group of conditions that affect
              the functioning of the brain and the nervous system... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'second')"
                >Show More</span
              >
            </p>
          </div> -->
          <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              ALZHEIMER'S DISEASE
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Alzheimer's disease is a progressive brain disorder that affects
              memory, thinking, and behaviour. It is the most... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'third')"
                >Show More</span
              >
            </p>
          </div>
          <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              AMYOTROPHIC LATERAL SCLEROSIS
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Amyotrophic lateral sclerosis, or ALS, is a rare and devastating
              neurological disorder that affects nerve cells in the brain...
              <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'forth')"
                >Show More</span
              >
            </p>
          </div>
          <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              PARKINSON'S DISEASE
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Parkinson's disease is a neurological disorder that affects the
              nervous system, causing tremors, stiffness, and... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'fifth')"
                >Show More</span
              >
            </p>
          </div>
          <div class="px-5 py-6 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold fsize16 mb-2">
              MULTIPLE SCLEROSIS
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 fsize14">
              Multiple Sclerosis (MS) is a chronic and progressive autoimmune
              disorder that affects the central nervous... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'sixth')"
                >Show More</span
              >
            </p>
          </div>

          <div class="px-4 py-8 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold text-lg mb-2">
              HUNTINGTON'S DISEASE
            </h2>
            <p class="mb-4 text-sm">
              Huntington's disease is a rare genetic disorder that affects the
              brain's nerve cells. It is a debilitating disease that... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'seventh')"
                >Show More</span
              >
            </p>
          </div>
          <div></div>
          <div class="px-4 py-8 rounded-lg border text-center bg-f6eaf3">
            <h2 class="text4F0A4B font-semibold text-lg mb-2">MIGRAINE</h2>
            <p class="mb-4 text-sm">
              Migraines are a type of headache that are often debilitating and
              can greatly impact the quality of life of those who... <br />
              <span
                class="text4F0A4B cursor-pointer"
                style="color: #cd4eaf"
                @click="handleClick('neurological_disorder', 'eight')"
                >Show More</span
              >
            </p>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="w-full lg:flex md:flex gap-10">
      <div class="lg:w-9/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
        <div class="mb-4">
          <h3 class="fsize32 sm-fsize24 text-primary font-semibold mb-2">
            Effects of Neurological Disorders on Patients
          </h3>
          <p class="fsize16 text-justify">
            Neurological Disorders can have a significant impact on patients'
            quality of life. As the disease progresses, patients may experience
            a decline in cognitive, motor, and sensory functions. They may
            require assistance with daily activities such as bathing, dressing,
            and eating. Additionally, they may experience emotional and
            psychological changes, such as depression, anxiety, and social
            withdrawal. These changes can make it difficult for patients to
            maintain their independence and engage in activities they once
            enjoyed.
          </p>
        </div>
      </div>
      <div class="lg:w-3/12 md:w-4/12 w-full">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/neurological_disorder/Support%20Required%20for%20Patients%20and%20Caregivers%20(1).jpg"
          alt="dementia"
          class="slcsupport_img1 object-cover"
        />
        <!-- </div>
        <div class="lg:w-3/12 md:w-4/12 w-full"> -->
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/neurological_disorder/Support%20Required%20for%20Patients%20and%20Caregivers%20(2).jpg"
          alt="dementia"
          class="slcsupport_img2 ml-9 mt-4 flex object-cover"
        />
      </div>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
  </div>
</template>
<script>
import SideBlogs from "../components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
  methods: {
    handleClick(name, tab) {
      this.$router.push({ name: name, query: { tab } });
    },
  },
};
</script>
